import dayjs from "dayjs";
import { useState } from "react";
import advancedFormat from "dayjs/plugin/advancedFormat";

import useSessionHistory from "../../../api/api-hooks/auth/sessions/useSessionHistory";
import ListItem from "../../../components/CRM/ListItem";
import AppTablePagination from "../../../components/AppTable/AppTablePagination";

dayjs.extend(advancedFormat);

const AccountSessionHistory = () => {
  const [queryPagination, setQueryPagination] = useState({
    Pagination: { Count: 25, Page: 1 },
  });
  const { sessionHistory, pagination, sessionHistoryLoading } =
    useSessionHistory(queryPagination);

  if (sessionHistoryLoading) {
    return (
      <>
        <ListItem loading={true} />
        <ListItem loading={true} />
      </>
    );
  }

  return (
    <>
      <h3 className="mb-0">Session History</h3>
      <div>
        <small>
          This is a list of the past and current devices that have logged into
          your account.
        </small>
      </div>
      <hr className="mt-2 mb-3"></hr>
      {sessionHistory?.length > 0 &&
        sessionHistory.map((session) => {
          const title =
            (session?.LocationFound
              ? `${session.City}, ${session.State} ${session.Country}`
              : "Unknown Location") + ` (${session.Ip})`;

          const subTitle =
            "Last Active: " +
            dayjs(session.LastUpdated).format("MMMM Do YYYY, h:mm:ss a");

          return (
            <ListItem
              key={session.id}
              title={title}
              subTitle={subTitle}
              icon="mdi-earth"
              optionsButton={null}
            />
          );
        })}
      <AppTablePagination
        records={sessionHistory}
        pagination={pagination}
        query={queryPagination}
        setQuery={setQueryPagination}
        loading={sessionHistoryLoading}
        module={{ Name: "SessionsHistory" }}
      />
    </>
  );
};

export default AccountSessionHistory;
